<template>
     <div>
          <Overlay :overlay="overlay" />
          <ViewAttachmentsIframeDialog :dialogViewAttachmentsIframe="dialogViewAttachmentsIframe" :s3FileKey="s3FileKey"
               @clicked="dialogViewAttachmentsIframeEmit"></ViewAttachmentsIframeDialog>
          <v-card density="compact" elevation="0" height="100%" class="mx-2">
               <div v-if="getAssetVerificationStatus === 'VERIFICATION_REQUIRED'"
                    class="d-flex align-center justify-center flex-column ga-2 my-1">
                    <div class="d-flex align-center justify-center">
                         <b class="text-center">Asset information</b>
                         <v-icon color="primary" size="x-small" class="mx-1" @click="refreshMethod">mdi-refresh</v-icon>
                    </div>

                    <div class="d-flex align-center flex-row justify-space-evenly w-100">
                         <v-btn color="primary" variant="flat" rounded="lg" size="small"
                              @click="pushToMaintenancePage()">
                              <v-icon size="small" class="mx-0">mdi-alert-circle</v-icon>Report issue
                         </v-btn>
                         <v-btn color="primary" variant="flat" rounded="lg" size="small" @click="pushToVerificationPage()">
                              <v-icon size="small" class="mx-0">mdi-shield-check</v-icon>Verify Asset
                         </v-btn>
                         <v-btn color="primary" size="small" rounded="lg" variant="flat"
                              @click="AssetDetailsPageLoginPageEMit(2)">Login
                         </v-btn>
                    </div>


               </div>
               <v-toolbar v-else density="compact" elevation="0" color="white">
                    <b class="text-center">Asset information</b>
                    <v-icon color="primary" size="x-small" class="mx-1" @click="refreshMethod">mdi-refresh</v-icon>
                    <v-spacer></v-spacer>

                    <v-btn color="primary" variant="flat" rounded="lg" size="small" class="mx-2"
                         @click="pushToMaintenancePage()">
                         <v-icon size="small" class="mx-1">mdi-alert-circle</v-icon>Report issue
                    </v-btn>
                    <v-btn color="primary" size="small" rounded="lg" variant="flat"
                         @click="AssetDetailsPageLoginPageEMit(2)">Login</v-btn>
               </v-toolbar>


               <v-card-text v-if="getAllListAssetDetailsArray.length > 0" class="pa-0 ma-0">
                    <v-row no-gutters>
                         <v-col cols="12">

                         </v-col>

                         <v-col cols="12">
                              <v-data-iterator :items="getAllListAssetDetailsArray">
                                   <template v-slot:default="{ items }">
                                        <v-row no-gutters>
                                             <v-col v-for="(item, i) in items" :key="i" cols="12">
                                                  <v-sheet border>
                                                       <v-row no-gutters>
                                                            <v-col cols="12" sm="12" xm="12" md="12"
                                                                 v-if="imageUrls && imageUrls.length > 0">
                                                                 <v-carousel v-model="carousel" :show-arrows="imageUrls.length>1"
                                                                      height="250" hide-delimiter-background
                                                                      delimiter-icon="mdi-circle" >
                                                                      <v-carousel-item
                                                                           :gradient="`to top right, rgba(255, 255, 255, .1), rgba(14, 151, 210, .15)`"
                                                                           v-for="(imageUrl, index) in imageUrls"
                                                                           :key="index" :src="imageUrl"
                                                                           lazy-src="@/assets/placeHolderImage.jpg"
                                                                           contain transition="fade-transition"
                                                                           reverse-transition="fade-transition">
                                                                      </v-carousel-item>
                                                                 </v-carousel>
                                                            </v-col>
                                                            <!-- <v-col cols="12" sm="12" xm="12"
                                                                 :md="imageUrls && imageUrls.length > 0 ? '4' : '12'">
                                                                 <v-img v-if="qrCodeUrl" :src="qrCodeUrl"
                                                                      :gradient="`to top right, rgba(255, 255, 255, .1), rgba(14, 151, 210, .15)`"
                                                                      max-height="250" max-width="100%"
                                                                      contain></v-img></v-col> -->
                                                       </v-row>

                                                       <v-list-item :title="item.raw.asset_name" density="comfortable"
                                                            lines="two" :subtitle="item.raw.asset_description"
                                                            max-width="100%">
                                                            <template v-slot:title>
                                                                 <strong class="text-h6 defaultFont">
                                                                      {{ item.raw.asset_name }}
                                                                 </strong>
                                                            </template>
                                                       </v-list-item>

                                                       <v-table class="text-caption" density="compact">
                                                            <tbody>
                                                                 <tr align="right">
                                                                      <th class="fontVariant2">
                                                                           <v-icon size="small" color="primary"
                                                                                class="mx-1">
                                                                                mdi-calendar</v-icon>
                                                                           Asset display id:
                                                                      </th>

                                                                      <td class="fontVariant2">
                                                                           {{ item.raw.asset_display_id }}
                                                                      </td>
                                                                 </tr>
                                                                 
                                                                 <tr align="right">
                                                                      <th class="fontVariant2">
                                                                           <v-icon size="small" color="primary"
                                                                                class="mx-1">
                                                                                mdi-calendar</v-icon>
                                                                           Asset serial No:
                                                                      </th>

                                                                      <td class="fontVariant2">
                                                                           {{ item.raw.asset_serial_no||'-' }}
                                                                      </td>
                                                                 </tr>

                                                                 <tr align="right">
                                                                      <th class="fontVariant2">
                                                                           <div class="d-flex align-center">
                                                                                <v-icon size="small" color="primary"
                                                                                     class="mx-1">
                                                                                     mdi-calendar</v-icon>

                                                                                <div>Asset date of procurement:</div>
                                                                           </div>
                                                                      </th>

                                                                      <td class="fontVariant2">
                                                                           {{
                                                                                item?.raw?.asset_date_of_procurement
                                                                                     ? formateEphochDateMethod(
                                                                                          item.raw.asset_date_of_procurement
                                                                                     )
                                                                                     : "-"
                                                                           }}
                                                                      </td>
                                                                 </tr>

                                                                 <tr align="right">
                                                                      <th class="fontVariant2">
                                                                           <v-icon size="small" color="primary"
                                                                                class="mx-1">
                                                                                mdi-map-marker</v-icon>Location:
                                                                      </th>

                                                                      <td class="fontVariant2">
                                                                           {{ getConcatedLocationName(item.raw) }}
                                                                      </td>
                                                                 </tr>
                                                                 <tr align="right">
                                                                      <th class="fontVariant2">
                                                                           <v-icon size="small" color="primary"
                                                                                class="mx-1">
                                                                                mdi-format-list-bulleted-type</v-icon>Category:
                                                                      </th>

                                                                      <td class="fontVariant2">
                                                                           {{ item.raw.category_name }} -
                                                                           {{ item.raw.sub_category_name }}
                                                                      </td>
                                                                 </tr>

                                                                 <tr align="right">
                                                                      <th class="fontVariant2">
                                                                           <v-icon size="small" color="primary"
                                                                                class="mx-1">
                                                                                mdi-package-variant</v-icon>Supplier:
                                                                      </th>

                                                                      <td class="fontVariant2">
                                                                           {{ item.raw.supplier_name }}
                                                                      </td>
                                                                 </tr>

                                                                 <tr align="right">
                                                                      <th class="fontVariant2">
                                                                           <div class="d-flex align-center">
                                                                                <v-icon size="small" color="primary"
                                                                                     class="mx-1">
                                                                                     mdi-factory</v-icon>
                                                                                <div>Manufacturer name:</div>
                                                                           </div>
                                                                      </th>

                                                                      <td class="fontVariant2">
                                                                           {{ item.raw.manufacturer_name }}
                                                                      </td>
                                                                 </tr>












                                                                 <tr align="right">
                                                                      <th class="fontVariant2">
                                                                           <v-icon size="small" color="primary"
                                                                                class="mx-1">
                                                                                mdi-list-status</v-icon>
                                                                           Status:
                                                                      </th>

                                                                      <td class="fontVariant1">
                                                                           <v-chip size="small" :color="item.raw.asset_status === 'ACTIVE'
                                                                                ? 'green'
                                                                                : 'red'
                                                                                ">
                                                                                <div class="fontVariant2">
                                                                                     {{ item.raw.asset_status }}
                                                                                </div>
                                                                           </v-chip>
                                                                      </td>
                                                                 </tr>

                                                                 <v-divider></v-divider>
                                                            </tbody>
                                                       </v-table>
                                                  </v-sheet>
                                             </v-col>
                                        </v-row>
                                   </template>
                              </v-data-iterator>
                         </v-col>
                         <v-col cols="12">
                              <v-card-text class="ma-2 pa-0">
                                   <v-card-title class="fontVarient6 font-bold">
                                        Asset Attachments
                                   </v-card-title>
                                   <v-text-field variant="outlined" elevation="0" density="compact" width="100%"
                                        class="field_label_size field_font" color="primary" label="Search"
                                        v-model="searchInArray">
                                        <template v-slot:prepend-inner>
                                             <div align="center">
                                                  <v-icon color="primary" size="small">mdi-magnify</v-icon>
                                             </div>
                                        </template>
                                   </v-text-field>
                                   <v-data-iterator :items="filterdAssetCerticatesArray" :items-per-page="itemsPerPage"
                                        v-if="filterdAssetCerticatesArray.length > 0">
                                        <template v-slot:header="{ page, pageCount, prevPage, nextPage }">
                                             <div class="d-flex align-center">
                                                  <v-spacer></v-spacer>
                                                  <v-btn variant="text" @click="onClickSeeAll">
                                                       <span class="text-decoration-underline text-none text-primary">See
                                                            all</span>
                                                  </v-btn>
                                                  <v-btn color="primary" :disabled="page === 1" icon="mdi-arrow-left"
                                                       size="small" variant="tonal" @click="prevPage"></v-btn>
                                                  <v-btn color="primary" :disabled="page === pageCount"
                                                       icon="mdi-arrow-right" size="small" variant="tonal"
                                                       @click="nextPage"></v-btn>
                                             </div>
                                        </template>

                                        <template v-slot:default="{ items }">
                                             <v-row>
                                                  <v-col v-for="(item, i) in items" :key="i" cols="12" sm="6" xl="3">
                                                       <v-sheet border>
                                                            <v-list-item :title="item.raw.name" density="comfortable"
                                                                 class="defaultFont">
                                                                 <template v-slot:prepend>
                                                                      <v-avatar color="primary" size="x-small"
                                                                           class="pa-0">
                                                                           <div class="fontVariant1">
                                                                                {{ i + 1 }}
                                                                           </div>
                                                                      </v-avatar>
                                                                 </template>
                                                                 <template v-slot:title>
                                                                      <strong class="text-h6 defaultFont">
                                                                           {{ item.raw.name }}
                                                                      </strong>
                                                                 </template>
                                                            </v-list-item>

                                                            <v-table class="text-caption" density="compact">
                                                                 <tbody>
                                                                      <tr align="right">
                                                                           <th class="defaultFont">Last modified:</th>

                                                                           <td class="defaultFont">
                                                                                {{
                                                                                     formateEphochDateMethod(
                                                                                          item.raw.lastModified
                                                                                     )
                                                                                }}
                                                                           </td>
                                                                      </tr>

                                                                      <tr align="right">
                                                                           <th class="defaultFont">Size:</th>

                                                                           <td class="defaultFont">
                                                                                <div class="defaultFont">
                                                                                     {{
                                                                                          convertBytesMethod(item.raw.size)
                                                                                     }}
                                                                                </div>
                                                                           </td>
                                                                      </tr>

                                                                      <tr align="right">
                                                                           <th class="defaultFont">Actions:</th>

                                                                           <td class="defaultFont">
                                                                                <div class="defaultFont">
                                                                                     <v-btn size="small" icon
                                                                                          elevation="0"
                                                                                          @click="downloadItemMethod(item.raw.key)">
                                                                                          <v-icon class="mx-1"
                                                                                               color="green">mdi-download-box</v-icon>
                                                                                     </v-btn>

                                                                                     <v-btn size="small" icon
                                                                                          elevation="0"
                                                                                          @click="viewFileDiloag('VIEW_FILE', item.raw.key)">
                                                                                          <v-icon class="mx-1"
                                                                                               color="primary">mdi-open-in-new</v-icon>
                                                                                     </v-btn>





                                                                                </div>
                                                                           </td>
                                                                      </tr>
                                                                 </tbody>
                                                            </v-table>
                                                       </v-sheet>
                                                  </v-col>
                                             </v-row>
                                        </template>

                                        <template v-slot:footer="{ page, pageCount }">
                                             <v-footer class="justify-space-between text-body-2 mt-4"
                                                  color="surface-variant defaultFont">
                                                  Total attachments:
                                                  {{ filterdAssetCerticatesArray.length }}

                                                  <div class="defaultFont">
                                                       Page {{ page }} of {{ pageCount }}
                                                  </div>
                                             </v-footer>
                                        </template>
                                   </v-data-iterator>

                                   <v-card-text v-else class="text-red fontVariant3 text-center">
                                        No Attachments Available</v-card-text>
                              </v-card-text>
                         </v-col>
                         <v-col cols="12">
                              <v-divider color="black" class="mt-2"></v-divider>
                              <v-card-text class="ma-2 pa-0">
                                   <v-card-title class="fontVarient6 font-bold">
                                        Asset Contracts
                                   </v-card-title>
                                   <v-text-field variant="outlined" elevation="0" density="compact" width="100%"
                                        class="field_label_size field_font" color="primary" label="Search"
                                        v-model="searchContractsInArray">
                                        <template v-slot:prepend-inner>
                                             <div align="center">
                                                  <v-icon color="primary" size="small">mdi-magnify</v-icon>
                                             </div>
                                        </template>
                                   </v-text-field>
                                   <v-data-iterator :items="filterAssetContractsArray"
                                        :items-per-page="itemsPerPageContracts"
                                        v-if="filterAssetContractsArray.length > 0">
                                        <template v-slot:header="{ page, pageCount, prevPage, nextPage }">
                                             <div class="d-flex align-center">
                                                  <v-spacer></v-spacer>
                                                  <v-btn variant="text" @click="onClickSeeAllContracts">
                                                       <span class="text-decoration-underline text-none text-primary">See
                                                            all</span>
                                                  </v-btn>
                                                  <v-btn color="primary" :disabled="page === 1" icon="mdi-arrow-left"
                                                       size="small" variant="tonal" @click="prevPage"></v-btn>
                                                  <v-btn color="primary" :disabled="page === pageCount"
                                                       icon="mdi-arrow-right" size="small" variant="tonal"
                                                       @click="nextPage"></v-btn>
                                             </div>
                                        </template>

                                        <template v-slot:default="{ items }">
                                             <v-row>
                                                  <v-col v-for="(item, i) in items" :key="i" cols="12" sm="6" xl="3">
                                                       <v-sheet border>
                                                            <v-list-item :title="item.raw.title" density="comfortable"
                                                                 class="defaultFont">
                                                                 <template v-slot:prepend>
                                                                      <v-avatar color="primary" size="x-small"
                                                                           class="pa-0">
                                                                           <div class="fontVariant1">
                                                                                {{ i + 1 }}
                                                                           </div>
                                                                      </v-avatar>
                                                                 </template>
                                                                 <template v-slot:title>
                                                                      <strong class="text-h6 defaultFont">
                                                                           {{ item.raw.title }}
                                                                      </strong>
                                                                 </template>
                                                            </v-list-item>

                                                            <v-table class="text-caption" density="compact">
                                                                 <tbody>
                                                                      <tr>
                                                                           <th>Contract Type:</th>
                                                                           <td>{{ item.raw.contract_type }}</td>
                                                                      </tr>

                                                                      <tr>
                                                                           <th>Status:</th>
                                                                           <td>{{ item.raw.contract_status }}</td>
                                                                      </tr>

                                                                      <tr>
                                                                           <th>Supplier:</th>
                                                                           <td>{{ item.raw.supplier_name || "-" }}</td>
                                                                      </tr>

                                                                      <tr>
                                                                           <th>Contact:</th>
                                                                           <td>{{ item.raw.contact_name }}</td>
                                                                      </tr>

                                                                      <tr>
                                                                           <th>Start Date:</th>
                                                                           <td>
                                                                                {{
                                                                                     formateEphochDateMethod(item.raw.start_date)
                                                                                }}
                                                                           </td>
                                                                      </tr>

                                                                      <tr>
                                                                           <th>End Date:</th>
                                                                           <td>
                                                                                {{
                                                                                     formateEphochDateMethod(item.raw.end_date)
                                                                                }}
                                                                           </td>
                                                                      </tr>
                                                                      <tr>
                                                                           <th>Attachment:</th>

                                                                           <td>
                                                                                <span v-if="item.raw.attachment">
                                                                                     {{ item.raw.attachment.name }}
                                                                                </span>

                                                                                <span v-else>
                                                                                     No Attachment
                                                                                </span>
                                                                           </td>
                                                                      </tr>

                                                                      <tr align="right" v-if="item.raw.attachment">
                                                                           <th class="defaultFont">Size:</th>

                                                                           <td class="defaultFont">
                                                                                <div class="defaultFont">
                                                                                     {{
                                                                                          convertBytesMethod(item.raw.attachment.size)
                                                                                     }}
                                                                                </div>
                                                                           </td>
                                                                      </tr>

                                                                      <tr align="right" v-if="item.raw.attachment">
                                                                           <th class="defaultFont">Actions:</th>

                                                                           <td class="defaultFont">
                                                                                <div class="defaultFont">
                                                                                     <v-btn size="small" icon
                                                                                          elevation="0"
                                                                                          @click="downloadItemMethod(item.raw.attachment.key)">
                                                                                          <v-icon class="mx-1"
                                                                                               color="green">mdi-download-box</v-icon>
                                                                                     </v-btn>

                                                                                     <v-btn size="small" icon
                                                                                          elevation="0"
                                                                                          @click="viewFileDiloag('VIEW_FILE', item.raw.attachment.key)">
                                                                                          <v-icon class="mx-1"
                                                                                               color="primary">mdi-open-in-new</v-icon>
                                                                                     </v-btn>



                                                                                </div>
                                                                           </td>
                                                                      </tr>
                                                                 </tbody>
                                                            </v-table>
                                                       </v-sheet>
                                                  </v-col>
                                             </v-row>
                                        </template>

                                        <template v-slot:footer="{ page, pageCount }">
                                             <v-footer class="justify-space-between text-body-2 mt-4"
                                                  color="surface-variant defaultFont">
                                                  Total Contracts:
                                                  {{ getAllListAssetContractsArray.length }}

                                                  <div class="defaultFont">
                                                       Page {{ page }} of {{ pageCount }}
                                                  </div>
                                             </v-footer>
                                        </template>
                                   </v-data-iterator>

                                   <v-card-text v-else class="text-red fontVariant3 text-center">
                                        No Contracts Available
                                   </v-card-text>
                              </v-card-text>
                         </v-col>

                    </v-row>
               </v-card-text>

               <v-card-text v-if="noDataText">
                    <ErrorMessageCard :noDataText="noDataText"> </ErrorMessageCard>
               </v-card-text>

          </v-card>
     </div>
</template>
<script>
import QRCode from "qrcode";
import Overlay from "@/components/Extras/Overlay.vue";
import ErrorMessageCard from "@/components/Extras/ErrorMessageCard.vue";
import ViewAttachmentsIframeDialog from "@/components/Forms/dialog/ViewAttachmentsIframeDialog.vue";
import { formateEphochDate } from "@/mixins/Extras/formateEphochDate";
import { getAllListAssetDetails } from "@/mixins/RestApis/getAllListAssetDetails";
import { getPresignedUrlRestApi } from "@/mixins/RestApis/getPresignedUrlRestApi";
import { convertBytes } from "@/mixins/Extras/convertBytes";
import { getAllListAssetContracts } from "@/mixins/RestApis/getAllListAssetContracts";
export default {
     components: {
          Overlay,
          ErrorMessageCard,
          ViewAttachmentsIframeDialog,
     },
     mixins: [getAllListAssetDetails, getAllListAssetContracts, formateEphochDate, convertBytes, getPresignedUrlRestApi],
     data() {
          return {
               getAllListAssetDetailsArray: [],
               overlay: false,
               mainCardHeight: 0,
               carousel: 0,
               noDataText: null,
               qrCodeUrl: "",
               searchInArray: "",
               searchContractsInArray: "",
               getAssetVerificationStatus: "",
               imageUrls: [],
               assetCerticatesArray: [],
               itemsPerPage: 4,
               itemsPerPageContracts: 4,
               s3FileKey: null,
               dialogViewAttachmentsIframe: false,

          };
     },
     async mounted() {
          await this.refreshMethod()
     },
     computed: {
          filterdAssetCerticatesArray() {
               const searchTerm = this.searchInArray.toLowerCase();
               return this.assetCerticatesArray.filter((item) =>
                    Object.values(item).some((value) =>
                         String(value).toLowerCase().includes(searchTerm)
                    )
               );
          },
          filterAssetContractsArray() {
               const searchTerm = this.searchContractsInArray.toLowerCase();
               return this.getAllListAssetContractsArray.filter((item) =>
                    Object.values(item).some((value) =>
                         String(value).toLowerCase().includes(searchTerm)
                    )
               );
          }
     },
     methods: {


          pushToMaintenancePage() {
               const assetDisplayId = this?.$route?.params?.qrDisplayId || null;
               if (assetDisplayId) {
                    this.$router.push(`/Report-Maintenance/${assetDisplayId}`);
               }
          },
          pushToVerificationPage() {
               const assetDisplayId = this?.$route?.params?.qrDisplayId || null;
               if (assetDisplayId) {
                    this.$router.push(`/Asset-Verification/${assetDisplayId}`);
               }
          },
          async downloadItemMethod(s3_key) {
               await this.getPresignedUrlRestApiMethod(s3_key, true);


          },

          viewFileDiloag(action, s3_key) {
               if (action === "VIEW_FILE") {
                    this.s3FileKey = s3_key
                    this.dialogViewAttachmentsIframe = true;
               }

          },

          onClickSeeAll() {
               this.itemsPerPage = this.itemsPerPage === 4 ? this.assetCerticatesArray.length : 4;

          },
          onClickSeeAllContracts() {
               this.itemsPerPageContracts = this.itemsPerPageContracts === 4 ? this.getAllListAssetContractsArray.length : 4
          },
          async refreshMethod() {
               this.mainCardHeight = window.innerHeight - 135;
               const qrDisplayId = this.$route.params.qrDisplayId;
               const qrCodeUrl = window.location.origin;
               await Promise.all([
                    this.getAllListAssetDetailsMethod(qrDisplayId, qrCodeUrl),
                    this.getAllListAssetContractsMethod(qrDisplayId, qrCodeUrl)
               ])

               console.log('asset veriffication status.........', this.getAllListAssetDetailsArray[0]?.asset_verification_status)
               this.getAssetVerificationStatus = this.getAllListAssetDetailsArray[0]?.asset_verification_status
               const url = this?.getAllListAssetDetailsArray[0]?.asset_qr_code_url;
               if (url) {
                    await this.generateQRCode(url);
               }

          },
          async generateQRCode(url) {
               try {
                    this.qrCodeUrl = await QRCode.toDataURL(url);
               } catch (error) {
                    //console.error("Error generating QR code:", error);
               }
          },
          getConcatedLocationName(item) {
               if (
                    item.root_location_id === item.parent_location_id &&
                    item.root_location_id === item.location_id &&
                    item.parent_location_id === item.location_id
               ) {
                    return item.location_name;
               } else if (
                    item.root_location_id === item.parent_location_id &&
                    item.root_location_id !== item.location_id
               ) {
                    return `${item.root_location_name}-${item.location_name}`;
               } else {
                    return `${item.root_location_name}-${item.parent_location_name}-${item.location_name}`;
               }
          },
          AssetDetailsPageLoginPageEMit(toggle) {
               this.$emit("clicked", toggle);
          },
          dialogViewAttachmentsIframeEmit(toggle) {
               this.dialogViewAttachmentsIframe = false;
          }
     },
};
</script>
